import { useTranslation } from 'react-i18next'

import { PdfViewerToolbarButton } from '../../PdfViewerToolbarButton'
import { PdfViewerToolbarMenu } from '../../PdfViewerToolbarMenu'

import {
  PDF_VIEWER_TOOLBAR_ZOOM_CHEVRON_ICON_PROPS,
  PDF_VIEWER_TOOLBAR_ZOOM_IN_ICON_PROPS,
  PDF_VIEWER_TOOLBAR_ZOOM_OUT_ICON_PROPS,
  QA_NAME_PDF_VIEWER_TOOLBAR_ZOOM_IN_BTN,
  QA_NAME_PDF_VIEWER_TOOLBAR_ZOOM_OUT_BTN,
  QA_NAME_PDF_VIEWER_TOOLBAR_ZOOM_VALUE_BTN,
} from './PdfViewerToolbarZoomTool.constants'
import {
  formatPdfViewerScale,
  getPdfViewerZoomSections,
} from './PdfViewerToolbarZoomTool.utils'

import * as styles from './PdfViewerToolbarZoomTool.module.css'

function PdfViewerToolbarZoomTool({
  isZoomInDisabled,
  isZoomOutDisabled,
  scale,
  scaleValue,
  onChangeScaleValue,
  onZoomIn,
  onZoomOut,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.PdfViewerToolbarZoomTool}>
      <PdfViewerToolbarMenu
        afterIconProps={PDF_VIEWER_TOOLBAR_ZOOM_CHEVRON_ICON_PROPS}
        buttonClassName={styles.scaleButton}
        qaName={QA_NAME_PDF_VIEWER_TOOLBAR_ZOOM_VALUE_BTN}
        sections={getPdfViewerZoomSections({
          scaleValue,
          onChangeScaleValue,
        })}
        text={formatPdfViewerScale(scale)}
        tooltip={t('PdfViewer.ZoomBtnKey')}
      />
      <PdfViewerToolbarButton
        disabled={isZoomOutDisabled}
        iconProps={PDF_VIEWER_TOOLBAR_ZOOM_OUT_ICON_PROPS}
        qaName={QA_NAME_PDF_VIEWER_TOOLBAR_ZOOM_OUT_BTN}
        titleKey='PdfViewer.ZoomOutBtnKey'
        onClick={onZoomOut}
      />
      <PdfViewerToolbarButton
        disabled={isZoomInDisabled}
        iconProps={PDF_VIEWER_TOOLBAR_ZOOM_IN_ICON_PROPS}
        qaName={QA_NAME_PDF_VIEWER_TOOLBAR_ZOOM_IN_BTN}
        titleKey='PdfViewer.ZoomInBtnKey'
        onClick={onZoomIn}
      />
    </div>
  )
}

export default PdfViewerToolbarZoomTool
